import { ChangeDetectionStrategy, Component, computed, inject, signal } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UtilityService } from '@eforall/common';
import { DashboardDialogFramePart, DialogAction, DialogContext, DialogService, DroplistItem, DroplistWidget } from '@eforall/dashboard';
import { ReadonlyAccessWidget } from '../../../../../../../ui/widget';
import { AcceleratorAreaService } from '../../../../accelerator-area.service';

@Component({
	selector: 'select-event-type-dialog',
	standalone: true,
	imports: [
		DashboardDialogFramePart,
		ReadonlyAccessWidget,
		DroplistWidget,
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './select-event-type.dialog.html',
})
export class SelectEventTypeDialog {
	public dialog: DialogContext<{ accSessionId: number, specialistNames: string }> = inject(MAT_DIALOG_DATA);
	public dialogRef = inject(MatDialogRef<SelectEventTypeDialog>);
	public accAreaService = inject(AcceleratorAreaService);
	public util = inject(UtilityService);
	public dialogService = inject(DialogService);

	public selectedEventTypeId = signal<number | undefined>(undefined);

	selectActionEnabled = signal(false);

	selectAction: DialogAction = {
		id: 'select',
		cssClass: signal(undefined),
		enabled: this.selectActionEnabled,
		visible: signal(true),
		text: signal('Select'),
		linkType: 'callback',
		callback: async () => this.selectedEventTypeId(),
		willCloseDialog: true,
	};

	cancelAction: DialogAction = {
		id: 'close',
		cssClass: signal(undefined),
		enabled: signal(true),
		visible: signal(true),
		text: signal('Close'),
		linkType: "no-action",
		willCloseDialog: true,
	};

	actions: DialogAction[] = [this.selectAction, this.cancelAction];

	icon = signal('fa-regular fa-hand-pointer');

	public isReadonly = computed(() => !this.accAreaService.canEdit());

	public readonly eventTypes = computed<DroplistItem[]>(() => [
		{
			uniqueId: 19,
			iconContext: {
				iconClass: 'fa-calendar-range',
				iconStyle: 'fa-solid',
				text: 'Meet The Team',
				hideText: 'never',
			},
			disabled: this.isReadonly() || !!this.accAreaService.data()?.events.find(e => e.eventTypeId === 19),
			customSort: 1
		},
		{
			uniqueId: 1,
			iconContext: {
				iconClass: 'fa-calendar-range',
				iconStyle: 'fa-solid',
				text: 'Final Presentation',
				hideText: 'never',
			},
			disabled: false,
			customSort: 2,
		},
		{
			uniqueId: 12,
			iconContext: {
				iconClass: 'fa-calendar-range',
				iconStyle: 'fa-solid',
				text: 'Showcase & Celebration',
				hideText: 'never',
			},
			disabled: !!this.accAreaService.data()?.events.find(e => e.eventTypeId === 12),
			customSort: 3,
			value: 12,
		}
	]);


	onViewDroplistChange(selectedItem: DroplistItem | undefined) {
		this.selectedEventTypeId.set(selectedItem?.uniqueId);
		this.selectActionEnabled.set(!!this.selectedEventTypeId());
	}

}
